import { HttpUrlEncodingCodec } from '@angular/common/http';

export class XVIHttpUrlEncodingCodec extends HttpUrlEncodingCodec {
  public encodeKey(key: string): string {
    return this.encode(key);
  }

  public encodeValue(value: string): string {
    return this.encode(value);
  }

  // workaround for valid composing of query.
  private encode(value: string): string {
    const val = super.encodeKey(value);

    return val.replace(/\+/gi, '%2B');
  }
}
